import type { AsyncLocalStorage } from 'async_hooks';
import type { FirebaseApp } from 'firebase/app';
import { getAuth as getAuthNative, type Auth } from 'firebase/auth';
import {
  Bytes as BlobNative,
  DocumentReference as DocumentReferenceNative,
  GeoPoint as GeoPointNative,
  getFirestore as getFirestoreNative,
  Timestamp as TimestampNative,
  VectorValue as VectorNative,
  type Firestore,
} from 'firebase/firestore';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace firebase {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  export namespace firestore {
    export type Blob = BlobNative;
    export type DocumentReference = DocumentReferenceNative;
    export type GeoPoint = GeoPointNative;
    export type Timestamp = TimestampNative;
    export type Vector = VectorNative;

    export const Blob = BlobNative;
    export const DocumentReference = DocumentReferenceNative;
    export const GeoPoint = GeoPointNative;
    export const Timestamp = TimestampNative;
    export const Vector = VectorNative;
  }
}

declare global {
  // eslint-disable-next-line no-var
  var firebaseContext: AsyncLocalStorage<{ app?: string; user?: string; fbApp: FirebaseApp }>;
}

/**
 * Returns the current Firebase app from the global local storage store, which is provided by Node.js `AsyncContext`.
 * This is needed to support per-user context in Firebase on the backend, handling multiple users at the same time, using authed access to Firebase.
 */
export function getApp(): FirebaseApp | undefined {
  return globalThis.firebaseContext?.getStore()?.fbApp ?? undefined;
}

export function getAuth(): Auth {
  return getAuthNative(getApp());
}

export function getFirestore(): Firestore {
  return getFirestoreNative(getApp()!);
}

/**
 * Re-exported `CountryCodes` enum from Gazetteer so that we don't have to keep casting it's type.
 */
export type { IEncryptionEnvelope } from '@bridebook/models/source/models/Suppliers/Apps/instagram.types';
export type { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
